module.exports = __webpack_public_path__ + "media/icons/check-a2b63c87.svg";